import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../../../api/api";
import PasswordInput from "../../Shared/Utils/PasswordInput";
import useRecaptcha from "../../../hooks/useRecaptcha";
import styles from "./AdminLogin.module.css";
import logo from "../../../assets/logo.svg";

const AdminLogin = () => {
  const { getRecaptchaToken } = useRecaptcha();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (!email || !password) {
      setErrorMessage("Please enter both email and password.");
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrorMessage("Invalid email format.");
      return;
    }

    try {
      const recaptchaToken = await getRecaptchaToken("admin_login");
      if (!recaptchaToken) {
        setErrorMessage("reCAPTCHA verification failed. Please try again.");
        return;
      }
      const response = await loginAdmin(email, password, recaptchaToken);
      localStorage.setItem("adminToken", response.data.token);
      localStorage.setItem("adminRole", response.data.role);
      console.log(`[AdminLogin] Login successful — email: ${email}, role: ${response.data.role}`);
      navigate("/dashboard");
    } catch (error) {
      if (error.response && error.response.data.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage("Something went wrong. Please try again.");
      }
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.topBar}>
        <img src={logo} alt="Company Logo" className={styles.logo} />
      </div>

      <form onSubmit={handleSubmit} className={styles.loginForm}>
        <h2 className={styles.heading}>Admin Login</h2>
        {errorMessage && (
          <p className={styles.errorMessage}>{errorMessage}</p>
        )}{" "}
        <div className={styles.formGroup}>
          <label className={styles.label}>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={styles.input}
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.label}>Password:</label>
          <PasswordInput
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
          />
          <p
            onClick={() => navigate("/forgot-password")}
            className={styles.forgotPassword}
          >
            Forgot Password?
          </p>
        </div>
        <button type="submit" className={styles.loginButton}>
          Login
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
